<section aria-labelledby="delivery-options-title">
  <div class="section-heading">
    <div>
      <h2 id="delivery-options-title">Request lockedspaces</h2>
    </div>
  </div>

  <div class="workbench">
    <form class="form-surface" #deliveryForm="ngForm" (ngSubmit)="submit()">
      <div class="form-grid">
        <div class="form-field">
          <label for="delivery-email">Email address</label>
          <input id="delivery-email" name="email" class="form-control" [(ngModel)]="model.email">
        </div>
        <div class="form-field">
          <label for="delivery-phone">Phone number</label>
          <input id="delivery-phone" name="phone" class="form-control" [(ngModel)]="model.phone">
        </div>
        <div class="form-field">
          <label for="delivery-street">Street address</label>
          <input id="delivery-street" name="streetAddress" class="form-control" [(ngModel)]="model.streetAddress" required>
        </div>
        <div class="form-field">
          <label for="delivery-street-number">Street number</label>
          <input id="delivery-street-number" name="streetNumber" class="form-control" [(ngModel)]="model.streetNumber" required>
        </div>
        <div class="form-field">
          <label for="delivery-city">City</label>
          <input id="delivery-city" name="city" class="form-control" [(ngModel)]="model.city" required>
        </div>
        <div class="form-field">
          <label for="delivery-country">Country</label>
          <select id="delivery-country" name="country" class="form-select" [(ngModel)]="model.country" required>
            <option value="SE">SE</option>
            <option value="DK">DK</option>
            <option value="FI">FI</option>
            <option value="NO">NO</option>
          </select>
        </div>
        <div class="form-field">
          <label for="delivery-postal-code">Postal code</label>
          <input id="delivery-postal-code" name="postalCode" class="form-control" [(ngModel)]="model.postalCode" required>
        </div>
        <div class="form-field">
          <label for="delivery-lock-id">Lock ID</label>
          <input id="delivery-lock-id" name="lockId" class="form-control" [(ngModel)]="model.lockId">
        </div>
        <div class="form-field">
          <label for="delivery-latitude">Latitude</label>
          <input id="delivery-latitude" name="latitude" type="number" step="any" class="form-control" [(ngModel)]="model.latitude" required>
        </div>
        <div class="form-field">
          <label for="delivery-longitude">Longitude</label>
          <input id="delivery-longitude" name="longitude" type="number" step="any" class="form-control" [(ngModel)]="model.longitude" required>
        </div>
        <div class="form-field full">
          <label for="delivery-capacity-type">Capacity type</label>
          <select id="delivery-capacity-type" name="capacityType" class="form-select" [(ngModel)]="model.capacityType" required>
            <option value="DELIVERY">DELIVERY</option>
            <option value="HANDOVER">HANDOVER</option>
            <option value="DROPOFF">DROPOFF</option>
          </select>
        </div>
        <div class="form-field">
          <label for="delivery-length">Length (mm)</label>
          <input id="delivery-length" name="length" type="number" class="form-control" [(ngModel)]="model.length" required>
        </div>
        <div class="form-field">
          <label for="delivery-width">Width (mm)</label>
          <input id="delivery-width" name="width" type="number" class="form-control" [(ngModel)]="model.width" required>
        </div>
        <div class="form-field">
          <label for="delivery-height">Height (mm)</label>
          <input id="delivery-height" name="height" type="number" class="form-control" [(ngModel)]="model.height" required>
        </div>
        <div class="form-field check-field">
          <input id="delivery-availability" name="forAvailabilityCheck" type="checkbox" class="form-check-input" [(ngModel)]="model.forAvailabilityCheck">
          <label for="delivery-availability">Availability check</label>
        </div>
      </div>
      <div class="form-actions">
        <button type="submit" class="btn btn-primary" [disabled]="deliveryForm.invalid">Submit request</button>
      </div>
    </form>

    <div>
      <app-api-endpoint [endpoint]="endpoint" />

      <aside class="guidance-panel" aria-label="Lockedspace request instructions">
        <p><strong>Description:</strong> Requests available lockedspaces for a user or location.</p>
        <ul>
          <li>The user is identified by email and/or phone number.</li>
          <li>The location is identified by address.</li>
        </ul>
        <p>The identifier depends on the lock-provider setup, such as phone or email for home deliveries and address for B2B deliveries.</p>
        <p><strong>Note:</strong> Results can be filtered by location, postal code, and preferred lock providers. Preferred-provider filtering is not configured in this view.</p>
        <p><strong>Expected Result:</strong> The returned lockedspaces can be booked from Access Request.</p>
      </aside>

      @if (lockedSpaces().length > 0) {
        <section class="table-surface" aria-labelledby="lockedspaces-result-title">
          <h3 id="lockedspaces-result-title">Available lockedspaces</h3>
          <div class="data-table-wrap">
            <table class="table table-striped align-middle">
              <thead>
                <tr>
                  <th scope="col">Lock ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">Provider</th>
                  <th scope="col">Method</th>
                  <th scope="col">Lockedspace ID</th>
                </tr>
              </thead>
              <tbody>
                @for (item of lockedSpaces(); track $index) {
                  <tr>
                    <td>{{ item['lockId'] }}</td>
                    <td>{{ item['displayName'] }}</td>
                    <td>{{ item['systemProvider'] }}</td>
                    <td>{{ item['lockMethod'] }}</td>
                    <td>{{ item['lockedSpaceId'] }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </section>
      }

      <app-api-result
        [endpoint]="endpoint"
        [showEndpoint]="false"
        [request]="call.request()"
        [response]="call.response()"
        [error]="call.error()"
      />
    </div>
  </div>
</section>